export default {
  1: 'Scheduled',
  2: 'Roster Defined',
  3: 'Ready To Start',
  4: 'Set 1 - Ready to Start',
  5: 'Set 1 - In Progress',
  6: 'Set 1 - Finished',
  7: 'Set 2 - Ready to Start',
  8: 'Set 2 - In Progress',
  9: 'Set 2 - Finished',
  10: 'Set 3 - Ready to Start',
  11: 'Set 3 - In Progress',
  12: 'Set 3 - Finished',
  13: 'Set 4 - Ready to Start',
  14: 'Set 4 - In Progress',
  15: 'Set 4 - Finished',
  16: 'Set 5 - Ready to Start',
  17: 'Set 5 - In Progress',
  18: 'Set 5 - Finished',
  24: 'Finished',
  25: 'Official Result',
  26: 'Corrected',
  27: 'Closed',
}



// WEBPACK FOOTER //
// ./src/matchStatus.js